import { useModalState } from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { useEffect } from "react";

import { OfflineIndicator } from "./OfflineIndicator";
import { useOnlineStatus } from "./useOnlineStatus";

/**
 * Container for OfflineIndicator
 * Gets the online status and updates the modal state accordingly
 */
export function OfflineIndicatorContainer() {
  const { isOnline, isInitialized } = useOnlineStatus();

  const modalState = useModalState("closed");

  useEffect(() => {
    if (isInitialized) {
      modalState.setModalStatus(isOnline ? "closed" : "open");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline, isInitialized]);

  return (
    <ThemeProvider theme={getTheme()}>
      <OfflineIndicator modalState={modalState} />
    </ThemeProvider>
  );
}
